/**
 * @generated SignedSource<<da85c035aca0d64ebf309041ba2b8e1d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileFollowContact_tradeFirm$data = {
  readonly publicProfile: {
    readonly urlLabel: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ContactDesignerModal_tradeFirm">;
  readonly " $fragmentType": "ProfileFollowContact_tradeFirm";
};
export type ProfileFollowContact_tradeFirm$key = {
  readonly " $data"?: ProfileFollowContact_tradeFirm$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileFollowContact_tradeFirm">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileFollowContact_tradeFirm",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContactDesignerModal_tradeFirm"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradeFirmType",
  "abstractKey": null
};

(node as any).hash = "f585a1b734a2b04b6d110fb5209519b8";

export default node;
